import useLocalStorage from '@hooks/useLocalStorage'

import { SplitButton } from '../../theme/components/SplitButton'

export { LocalStorageSplitButton }

interface Props<T> {
  name: string
  storable: T
  onLoad: (params: T) => void
  onReset: () => void
}

const LocalStorageSplitButton = <T extends object>({
  name,
  storable,
  onLoad,
  onReset,
}: Props<T>) => {
  const { available, save, item } = useLocalStorage(name, storable)

  const filterOptions = [{ label: 'Filters resetten', onClick: onReset }]

  if (available) {
    filterOptions.push(
      {
        label: 'Opgeslagen filters laden',
        onClick: () => onLoad(item),
      },
      {
        label: 'Filters opslaan',
        onClick: save,
      },
    )
  }

  return <SplitButton options={filterOptions} />
}
